import { isPlatformServer } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID, TransferState, makeStateKey } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Job, PagedResponse } from '@interfaces';
import { Observable, of } from 'rxjs';
import { catchError, first, map, tap } from 'rxjs/operators';
import { MetadataService } from 'src/app/services/meta-service.service';
import { JobsService } from '../jobs.service';
@Injectable({ providedIn: 'root'})
export class JobsExternalResolverService  {
	constructor(private jobService: JobsService) { }
	public resolve(): Observable<any> {
		const query = {
			employer: null
		};
		return this.jobService.find(query);
	}
}

@Injectable({ providedIn: 'root'})
export class JobResolverService  {
	constructor(
		private jobService: JobsService,
		private transferState: TransferState,
		private router: Router,
		private meta: MetadataService,
		@Inject(PLATFORM_ID) private platformId,
	) { }

    private resolveBySlug(slug: string): Observable<Job | boolean> {
        const SINGLE_KEY = makeStateKey<Job>('job-' + slug);
		if (this.transferState.hasKey(SINGLE_KEY)) {
			const job = this.transferState.get<Job>(SINGLE_KEY, null);
			if(job.archived === true) {
				this.router.navigate(['page-not-found']);
				return of(false);
			}
            this.transferState.remove(SINGLE_KEY);
			this.meta.setupJobMetaTags(job);
			return of(job);
		} else {
			return this.jobService.get(slug).pipe(
				first(),
				tap((job: Job) => {
					if(job.archived === true) {
						this.router.navigate(['page-not-found']);
						return of(false);
					}
					if(isPlatformServer(this.platformId)) {
						this.transferState.set(SINGLE_KEY, job);
						try {
							this.meta.setupJobMetaTags(job);
						} catch(e) {
							console.log(e);
						}
					}
				}),
				catchError((error: HttpErrorResponse) => {
					if(error.status === 404) {
						this.router.navigate(['page-not-found']);
					} else{
						this.router.navigate(['error']);
					}
					return of(false);
				})
			);
		}
    }

    private resolveByGhJobId(id: string, route: ActivatedRouteSnapshot): Observable<Job | boolean> {
			return this.jobService.find({ "ghJobId": id }).pipe(
				first(),
				map((results: PagedResponse<Job>) => {
                    return results?.data?.[0] ?? null
                }),
				tap((job: Job) => {
                    if(!job) {
                        this.router.navigate(['page-not-found']);
                        return of(false);
                    }
					else if(job.archived === true) {
						this.router.navigate(['page-not-found']);
						return of(false);
					}
                    return this.router.navigate(['jobs', job.slug], { queryParams: route.queryParams });
				}),
				catchError((error: HttpErrorResponse) => {
					if(error.status === 404) {
						this.router.navigate(['page-not-found']);
					} else{
						this.router.navigate(['error']);
					}
					return of(false);
				})
			);
    }

	public resolve(route: ActivatedRouteSnapshot): Observable<any> {
		const slug = route.params['slug'];
		const ghJobId = route.params['ghJobId'];

        if(slug) {
            return this.resolveBySlug(slug);
        } else if(ghJobId) {
            return this.resolveByGhJobId(ghJobId, route);
        }
    }
}
